module.exports = __webpack_public_path__ + "img/orangeLife_visual.f90b8e8c.jpg";